const isDate = (value?: unknown): value is Date => value instanceof Date;

export { isDate };
